import { Seo } from '../components/Seo';
import { LEGAL_PAGES } from '../lib/config';

const page = LEGAL_PAGES.find((p) => p.path === '/privacy')!;

export function PrivacyPage() {
  return (
    <>
      <Seo page={page} />
      <section className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-extrabold text-text-primary sm:text-4xl">{page.h1}</h1>
        <p className="mt-2 text-sm text-text-secondary">Effective Date: July 26, 2026</p>

        <div className="prose prose-invert mt-8 max-w-none">
          <h2>1. Introduction</h2>
          <p>
            Image Enlarger operates https://imageenlarger.co. This Privacy Policy explains how we
            collect, use, and protect information when you use our AI image upscaling tool.
          </p>

          <h2>2. Information We Collect</h2>
          <h3>Images you upload</h3>
          <p>
            Uploaded images and AI-generated outputs are temporarily stored only for the time needed
            to process your request. Images are automatically deleted as soon as processing is
            complete, usually within minutes and no later than 24 hours. We do not use your images to
            train AI models.
          </p>

          <h3>Device identifier</h3>
          <p>
            To enforce the free daily quota without requiring registration, we generate an anonymous
            device identifier and store it in your browser via localStorage. This identifier is not
            linked to your name, email, or any personally identifiable information. You can reset it
            by clearing browser data for imageenlarger.co.
          </p>

          <h3>Technical logs</h3>
          <p>
            We keep limited server logs for reliability, debugging, and abuse prevention. Logs may
            include your IP address, browser type, requested URL, timestamps, and upload metadata.
            Logs are retained for up to 90 days.
          </p>

          <h2>3. How We Use Information</h2>
          <p>
            We use information to process upscaled images, enforce usage limits, maintain the
            Service, and respond to support requests. We do not sell your information, use your
            images to train AI models, or build advertising profiles.
          </p>

          <h2>4. Third-Party Services</h2>
          <p>
            We rely on Cloudflare (Pages, Workers, R2, D1) for hosting, compute, storage, and
            database services. AI inference may be handled by a placeholder backend service in this
            first version. Third-party providers have their own privacy policies.
          </p>
          <p>
            We do not use Google Analytics, advertising pixels, or other third-party tracking tools
            in the first version.
          </p>

          <h2>5. Cookies and Tracking</h2>
          <p>
            We do not use cookies or tracking technologies for analytics or advertising. The
            anonymous device identifier stored in localStorage is not a third-party cookie.
          </p>

          <h2>6. Data Retention</h2>
          <ul>
            <li>
              Uploaded images and outputs: deleted as soon as processing is complete, no later than
              24 hours.
            </li>
            <li>
              Device identifier: retained while you use the Service; reset when you clear browser
              data.
            </li>
            <li>Server logs: up to 90 days.</li>
          </ul>

          <h2>7. Your Rights</h2>
          <p>
            You can control your data by clearing browser data for imageenlarger.co or refraining
            from uploading images you do not want processed. To request deletion of stored logs or
            support records, email support@imageenlarger.co.
          </p>

          <h2>8. Children’s Privacy</h2>
          <p>
            The Service is not intended for children under 13. We do not knowingly collect personal
            information from children under 13. If you believe we have collected such information,
            please contact support@imageenlarger.co.
          </p>

          <h2>9. Changes</h2>
          <p>
            We may update this Privacy Policy from time to time. Changes will be posted on this page
            with an updated effective date.
          </p>

          <h2>10. Contact Us</h2>
          <p>
            Email:{' '}
            <a href="mailto:support@imageenlarger.co">support@imageenlarger.co</a>
          </p>
        </div>
      </section>
    </>
  );
}
